import { render, staticRenderFns } from "./LObjectCardRelated.vue?vue&type=template&id=eab9bcf2&scoped=true&"
import script from "./LObjectCardRelated.vue?vue&type=script&lang=js&"
export * from "./LObjectCardRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab9bcf2",
  null
  
)

export default component.exports